import actionTypes from "actions/actionTypes";

const initialState = {
  basicUsage: {},
};

const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BASIC_USAGE_DATA:
      return {
        ...state,
        basicUsage: action.payload
      };
      case actionTypes.RESET_BASIC_USAGE:
        return { ...state, basicUsage: {} };
    default:
      return state;
  }
};

export default reportsReducer;
